export enum Pages {
  Chat = '/',
  PDFViewer = '/pdf-viewer',
  VideoViewer = '/video-viewer',
  Disclaimer = '/disclaimer',
  TopicPicker = '/topic-picker',
  NotFound = '*',
}
